import { useCallback, useEffect, useRef } from 'react';

/* Red obrade slika u Web Workerima (2–4 paralelno, prema broju jezgara, + 1 rezerva za prioritet). Svaka slika ide jednom;
   rezultat se javlja kroz onDone(key, poruka) — { ok, result, sha256, width, height, urls } ili { ok:false, error }. */
const POOL = Math.max(2, Math.min(4, (typeof navigator !== 'undefined' && navigator.hardwareConcurrency) ? navigator.hardwareConcurrency - 1 : 2));

export default function useObrada(onDone) {
    const workers = useRef([]);
    const queue = useRef([]);
    const busy = useRef(new Map()); // worker -> key
    const cb = useRef(onDone);
    cb.current = onDone;

    const pump = useCallback(() => {
        workers.current.forEach((w, wi) => {
            if (busy.current.has(w) || !queue.current.length) return;
            /* poslednji worker je rezerva samo za prioritet (ponovna obrada listića koji operater gleda) — kreće odmah */
            const i = wi === POOL ? queue.current.findIndex((x) => x.prioritet) : 0;
            if (i < 0) return;
            const { key, file, polozaj } = queue.current.splice(i, 1)[0];
            busy.current.set(w, key);
            w.postMessage({ id: key, file, polozaj });
        });
    }, []);

    const ensure = useCallback(() => {
        if (workers.current.length) return;
        for (let i = 0; i <= POOL; i++) {
            const w = new Worker(new URL('./engine/worker.js', import.meta.url));
            w.onmessage = (e) => {
                const msg = e.data;
                busy.current.delete(w);
                const urls = {};
                if (msg.ok) Object.entries(msg.blobs).forEach(([k, b]) => { urls[k] = URL.createObjectURL(b); });
                cb.current(msg.id, msg.ok ? { ok: true, result: msg.result, sha256: msg.sha256, width: msg.width, height: msg.height, urls } : msg);
                pump();
            };
            w.onerror = (err) => {
                const key = busy.current.get(w);
                busy.current.delete(w);
                if (key != null) cb.current(key, { ok: false, error: err.message || 'Greška pri obradi slike' });
                pump();
            };
            workers.current.push(w);
        }
    }, [pump]);

    /* prioritet: ponovna obrada listića koji operater upravo gleda (ručni položaj) ide ispred ostatka foldera */
    const dodaj = useCallback((items, { prioritet = false } = {}) => {
        ensure();
        if (prioritet) queue.current.unshift(...items.map((x) => ({ ...x, prioritet: true }))); else items.forEach((x) => queue.current.push(x));
        pump();
    }, [ensure, pump]);

    const otkazi = useCallback(() => { queue.current = []; }, []);

    useEffect(() => () => workers.current.forEach((w) => w.terminate()), []);

    return { dodaj, otkazi, uRedu: () => queue.current.length + busy.current.size };
}
